import styled from 'styled-components';
import { StyledModal } from '../../../common/shared/modal.styled';

export const StyledTenantRecordConfirmModal = styled(StyledModal)`
  .modal-dialog {
    max-width: 800px;

    .modal-body {
      .content {
        text-align: center !important;
      }
      
      .buttons {
        margin-top: 30px;
        display: flex;
        justify-content: center;
        
        button {
          width: 200px;
          margin: 0 10px;
        }
      }
    }
  }
`;